import * as React from "react";
import { Component } from "react";
import { Button, Glyphicon, Nav, Navbar, NavItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import GuaranteedPowerTable from "src/components/projects/project/powerTable/GuaranteedPowerTable";
import { TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import {
  IGuaranteedPowerTablePageProps,
  IGuaranteedPowerTablePageState,
  IGuaranteedPowerTableRow,
} from "./interfaces";

export default class GuaranteedPowerTablePage extends Component<
  IGuaranteedPowerTablePageProps,
  IGuaranteedPowerTablePageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  private guaranteedPowerTableCollection: firebase.firestore.CollectionReference;
  private unsubscribe: any;
  public constructor(props: IGuaranteedPowerTablePageProps) {
    super(props);

    this.state = {
      loading: true,
      guaranteedPowerTable: [],
    };

    this.renderProjectNavbar = this.renderProjectNavbar.bind(this);
    this.updateGuaranteedPowerTable = this.updateGuaranteedPowerTable.bind(this);
    this.addRow = this.addRow.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.updateRow = this.updateRow.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
    this.guaranteedPowerTableCollection = this.projectDocument.collection("guaranteedPowerTable");
    this.unsubscribe = this.guaranteedPowerTableCollection
      .orderBy("productionAnniversary")
      .onSnapshot(this.updateGuaranteedPowerTable);
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public componentWillUnmount() {
    this.unsubscribe(this.updateGuaranteedPowerTable);
  }

  public render() {
    return (
      <div className="statements-grid container-fixed-navbar">
        {this.renderProjectNavbar()}
        <GuaranteedPowerTable
          appService={this.props.appService}
          guaranteedPowerTable={this.state.guaranteedPowerTable}
          deleteRow={this.deleteRow}
          updateRow={this.updateRow}
        />
      </div>
    );
  }

  private renderProjectNavbar() {
    const id = this.props.appService.getActiveProjectId();
    return (
      <div className="subnavbar-container">
        <Navbar collapseOnSelect={true}>
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink to={`/project/${id}`}>
                <Glyphicon glyph="glyphicon glyphicon-circle-arrow-left" className="button-right" />
                Back to {this.props.appService.getActiveProjectLocation()} Statements
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight={true}>
              <NavItem>
                <Button bsStyle="success" bsSize="small" onClick={this.addRow}>
                  <Glyphicon glyph="glyphicon glyphicon-plus-sign" className="button-right" />
                  Add
                </Button>
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }

  private addRow() {
    this.guaranteedPowerTableCollection.add({
      productionAnniversary: 0,
      cumulativeEstimatedPower: 0,
      cumulativeGuaranteedPower: 0,
      averageEstimatedPower: 0,
      averageGuaranteedPower: 0,
      leasePayment: 0,
      budgetPayment: 0,
    });
  }
  private deleteRow(guaranteedPowerTableRow: IGuaranteedPowerTableRow): void {
    this.guaranteedPowerTableCollection.doc(guaranteedPowerTableRow.id).delete();
  }
  private updateRow(row: IGuaranteedPowerTableRow): void {
    this.guaranteedPowerTableCollection.doc(row.id).update({
      productionAnniversary: row.productionAnniversary,
      cumulativeEstimatedPower: row.cumulativeEstimatedPower,
      cumulativeGuaranteedPower: row.cumulativeGuaranteedPower,
      averageEstimatedPower: row.averageEstimatedPower,
      averageGuaranteedPower: row.averageGuaranteedPower,
      leasePayment: row.leasePayment,
      budgetPayment: row.budgetPayment,
    });
  }
  private updateGuaranteedPowerTable(querySnapshot: firebase.firestore.QuerySnapshot) {
    const guaranteedPowerTable: IGuaranteedPowerTableRow[] = [];
    querySnapshot.forEach(doc => {
      const {
        productionAnniversary,
        cumulativeEstimatedPower,
        cumulativeGuaranteedPower,
        averageEstimatedPower,
        averageGuaranteedPower,
        leasePayment,
        budgetPayment,
      } = doc.data();
      guaranteedPowerTable.push({
        id: doc.id,
        productionAnniversary,
        cumulativeEstimatedPower,
        cumulativeGuaranteedPower,
        averageEstimatedPower,
        averageGuaranteedPower,
        leasePayment,
        budgetPayment,
      });
    });
    this.setState({ loading: false, guaranteedPowerTable });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/powerTable/GuaranteedPowerTablePage.tsx